import {createSvgIcon} from '../create-svg-icon';

export const TrendingFlatIcon = createSvgIcon(
  <path d="m22 12-4-4v3H3v2h15v3l4-4z" />
, 'TrendingFlatOutlined');
